
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[eventId]/share",
      function () {
        return require("private-next-pages/events/[eventId]/share.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[eventId]/share"])
      });
    }
  